export const en = {
  nav: { guides: "Guides", pricing: "Pricing", login: "Log in", start: "Start free", credits: "credits", credit: "credit", quick: "Quick access", dashboard: "My dashboard", buy: "Buy credits", logout: "Log out" },
  footer: {
    tagline: "Make any file print-ready, at home or at the print shop. AI tools for everyone who prints, and for print shops too.",
    tools: "Tools", allTools: "All tools", guides: "Guides", account: "Account", pricing: "Pricing", dashboard: "My dashboard", login: "Log in", rights: "Print-ready files for everyone",
  },
  tools: {
    ampliar: {
      name: "HD Upscale",
      short: "Fixes blurry, small or pixelated images",
      description: "Small, blurry or pixelated image? The AI rebuilds the details so it prints sharp, even at large sizes like posters and banners.",
      badges: ["Up to 4x larger", "300/600 DPI", "RGB + CMYK"],
    },
    vetorizar: {
      name: "Vectorize logo",
      short: "Logo that prints crisp at any size",
      description: "Turn your logo into a vector that prints crisp at any size, for stickers, signs, banners and cutting. Opens in CorelDRAW and Illustrator.",
      badges: ["SVG · PDF · EPS · AI", "Corel & Illustrator"],
    },
    "remover-fundo": {
      name: "Remove background",
      short: "Transparent background in one click",
      description: "Remove the background in one click for stickers, mugs, T-shirts, labels and product photos. Download a high-quality transparent PNG.",
      badges: ["Transparent PNG", "Precise edges"],
    },
    "pdf-imagem": {
      name: "PDF to image",
      short: "Turns PDF pages into JPG, PNG, BMP or TIFF",
      description: "Turn each PDF page into a high-quality image (JPG, PNG, BMP or TIFF) to print, post or send to the print shop. One page or all as a ZIP.",
      badges: ["Up to 600 DPI", "JPG · PNG · BMP · TIFF"],
    },
  },
  formatHint: { svg: "Universal · Corel & Illustrator", pdf: "Vector · opens anywhere", eps: "Print classic · Corel", ai: "Illustrator (PDF-compatible)", png: "Image preview" },
  landing: {
    badge: "Print-ready files in minutes",
    h1a: "We enhance",
    h1b: "your images,",
    h1c: "in one click.",
    sub: "Blurry photo, pixelated logo or a PDF you need as an image? Fix it in seconds and print at home or send it to any print shop without the file being rejected.",
    cta: "Get my 5 free images",
    after: "Then US$5 per 10 uses",
    checks: ["No design skills needed", "Home printers and print shops", "No card to start"],
    output: "Ready to print",
    imgAlt: "Printed materials",
    audienceEyebrow: "Who it's for",
    audienceTitle: "Made for anyone who needs to print",
    personal: {
      tag: "Printing something?",
      title: "Your file, sharp on paper",
      text: "Invitations, flyers, stickers, banners, photos, T-shirts. Upload what you have and get a file your home printer or print shop will accept: sharp, big enough and in the right format.",
      bullets: ["Fix small or blurry images before printing", "Logos as vectors for stickers, signs and cutting", "Cut out backgrounds for mugs, shirts and labels", "Turn PDFs into images to print or share"],
      cta: "Fix my file",
    },
    shop: {
      tag: "Run a print shop?",
      title: "Stop sending files back",
      text: "Rescue your clients' low-res artwork, vectorize logos for Corel and Illustrator and deliver CMYK files ready for the press, in minutes.",
      bullets: ["CMYK and DPI embedded in the file", "SVG, PDF, EPS and AI for Corel and Illustrator", "Pay per use, no subscription"],
      cta: "See pricing",
    },
    toolsEyebrow: "04 tools",
    toolsTitle: "Four tools to fix any file before printing",
    useTool: "Use tool",
    stepsEyebrow: "How it works",
    steps: [
      { title: "Upload your file", text: "Image, logo or PDF, straight from your phone or computer." },
      { title: "The AI fixes it", text: "Sharper, larger, vectorized or without background, in seconds." },
      { title: "Download and print", text: "Choose the format. RGB for home printers, CMYK for print shops." },
    ],
    features: [
      { title: "Simple for anyone", text: "No Photoshop, no design skills. Upload, click and download." },
      { title: "Professional results", text: "The same kind of AI used by studios, with high-resolution, print-ready output." },
      { title: "Pay only if you use it", text: "5 free uses. Then US$5 per 10 uses on any tool. Credits never expire." },
    ],
    ctaTitle: "Your first 5 files are free.",
    ctaSub: "Sign in with Google in seconds. No card needed.",
    ctaBtn: "Create free account",
  },
  auth: {
    google: "Continue with Google",
    googleError: "Couldn't sign in with Google. Please try again.",
    registerTitle: "Create your account", loginTitle: "Log in",
    registerSub: "Sign in with Google and get 5 free images on any tool.", loginSub: "Sign in with Google to use your 5 free images and your history.",
    orEmail: "admin access", adminLogin: "Admin login with email", googleOnlyNote: "Only Google accounts can use credits.", name: "Name", email: "Email", password: "Password",
    registerBtn: "Create account", loginBtn: "Log in",
    hasAccount: "Already have an account?", noAccount: "Don't have an account yet?", signup: "Sign up",
    welcomeNew: "Account created! You got 5 credits.", welcomeBack: "Welcome back!",
  },
  dash: {
    eyebrow: "Dashboard", hello: "Hi, {name}", balance: "Available balance",
    perFile: "credits · free preview, 1 credit per download", buy: "Buy 10 for US$5",
    history: "File history", files: "{n} files", removed: "File removed from history",
    confirmTitle: "Remove this file?", confirmText: "\"{name}\" will be removed from your history. This can't be undone.", cancel: "Cancel", remove: "Remove",
  },
  history: {
    empty: "No files yet. Pick a tool and upload your first file.",
    processing: "Processing", failed: "Failed", done: "Ready", unlocked: "Unlocked · free downloads",
  },
  tool: {
    newFile: "New file", processingTitle: "Processing {file}",
    processingSlow: "The AI is rebuilding the details. This can take 20 seconds to 2 minutes.",
    processingFast: "This usually takes a few seconds.",
    uploading: "Uploading...", uploadPdf: "Upload your PDF", uploadImg: "Upload your image",
    hintPdf: "PDF up to 40 MB and 60 pages", hintImg: "PNG, JPG, WEBP, BMP or TIFF up to 40 MB and 100 megapixels",
    tooBig: "{name} is {mb} MB. The limit is 40 MB: compress or resize the image and try again.",
    tooManyPixels: "{name} has {mp} megapixels ({w}×{h}). The limit is 100 MP: resize the image and try again.",
    clickOrDrag: "Click or drag the file here",
    tryAnother: "Try another file", ready: "File ready!",
    noCredits: "Out of credits. Buy a pack to continue.",
    export: "Export", pages: "{n} pages", page1: "1 page", settings: "Settings",
    chooseLater: {
      upscale: "You choose format, color (RGB/CMYK) and DPI after processing.",
      pdf: "You choose format, color (RGB/CMYK) and DPI after processing.",
      remove_bg: "You choose the format (PNG, TIFF, WEBP or JPG) and DPI after processing.",
      vectorize: "You choose the vector format (SVG, PDF, EPS or AI) after processing.",
    },
    costs: "Free preview · 1 credit per download", balance: "Balance: {n}", buy: "Buy credits",
    quality: "Quality", ultra: "Ultra AI", ultraHint: "Natural restoration, best for photos and faces",
    fast: "Faithful", fastHint: "Faster, keeps the original look",
    scale: "Enlargement", x2Hint: "Doubles the resolution", x4Hint: "Ultra for print",
  },
  vec: {
    recraft: "Recraft AI", recraftHint: "Clean, smooth shapes, great for color logos",
    precise: "Precise trace", preciseHint: "Follows every edge, great for small letters and symbols",
    compare: "We ran 2 engines. Compare and click the best one: you only pay for the download you pick.", single: "Vectorized result",
    choose: "Choose", selected: "Selected", zoom: "View larger", downloading: "Downloading the {e} version",
    enhance: "Sharpen small letters", enhanceOn: "On", enhanceOnHint: "AI upscale before vectorizing (a few seconds more)",
    enhanceOff: "Off", enhanceOffHint: "Faster, uses the image as is",
  },
  renew: {
    title: "We couldn't renew your Print Shop plan", text: "The automatic charge failed. Renew to get this month's 100 credits and use batch upload again.", cta: "Renew now", redirecting: "Opening secure payment...",
  },
  batch: {
    title: "Batch", progress: "{d} of {n} ready", open: "Open", back: "Back to batch", uploading: "Uploading {i} of {n}...", queued: "Queued",
    planOnly: "Batch upload is a Print Shop plan feature. We only sent the first file.", hint: "Batch upload: select several files at once", upsell: "Want to send many files at once? See the Print Shop plan", max: "Maximum {n} files per batch",
  },
  result: {
    original: "Original", result: "Result", noBg: "No background", dragHint: "Drag the handle to compare before and after", showNoBg: "Show without background", showOriginal: "Show original",
    bitmap: "Original bitmap", vector: "Vector (curves)", page: "Page {n}",
  },
  dl: {
    format: "File format", color: "Color profile", rgbHint: "Home printers, screens and web", cmykHint: "Print shops (offset & digital)",
    cmykOnly: "Available in JPG, TIFF and PDF", resolution: "Embedded resolution",
    dpiHints: { 150: "Draft", 300: "Print standard", 600: "High precision" },
    pages: "Pages", all: "All ({n})", zip: "ZIP pack", onlyPage: "Only page {n}", single: "Single file",
    jpgNoAlpha: "JPG doesn't support transparency: the background will be white.",
    vectorTip: "In CorelDRAW use File › Import (SVG, PDF or EPS). In Illustrator, open the .AI or PDF directly.",
    download: "Download", free: "Each download uses 1 credit.", freeUnlimited: "Unlimited downloads on your account.",
    freeUnlocked: "File already unlocked: download again in any format at no extra cost.", doneFree: "Download started! No credit used.",
    confirmTitle: "Download this file?", confirmText: "This download will use 1 credit. Your current balance: {n}.", confirmBtn: "Use 1 credit and download", cancel: "Cancel",
    noCredits: "You need 1 credit to download the clean file.", buy: "Buy credits", downloading: "Preparing file...", done: "Download started! 1 credit used.",
    lockedTitle: "Watermarked preview", lockedText: "Like it? Download to get the clean high-resolution file.",
  },
  pricing: {
    eyebrow: "Pricing", title: "Simple and fair.",
    sub: "See the result free with a watermark. Each download uses 1 credit, on any tool. Credits never expire.",
    free: "Free", toStart: "to get started",
    freeList: ["5 free uses when you sign up", "All 4 tools", "Free preview before you pay", "File history"],
    pack: "Pack", credits10: "{n} credits", perFile: "{n} credits · {per} per file", extraNote: "Each extra pack is 10% off: {price}", save: "You save {v}",
    packs: "{n} packs", pack1: "1 pack", buyBtn: "Buy {n} credits", secure: "Secure payment via Stripe",
    cancelled: "Payment cancelled. You were not charged.",
    shop: "Print Shop plan", shopTag: "For print shops", perMonth: "/month", shopCredits: "100 credits per month · {per} per file",
    shopList: ["100 credits every month", "Unused credits roll over", "Batch upload: many files at once", "Cancel anytime"],
    subscribe: "Subscribe to Print Shop", active: "Your plan is active", renews: "Renews on {d} with +100 credits", endsOn: "Cancelled · active until {d}",
    cancelPlan: "Cancel plan", resumePlan: "Keep plan", cancelTitle: "Cancel the Print Shop plan?", cancelText: "You keep the plan and your credits until {d}. After that you won't be charged again.", keep: "Go back", confirmCancel: "Yes, cancel",
    cancelDone: "Plan cancelled. It stays active until the end of the period.", resumeDone: "Your plan stays active.",
  },
  pay: {
    checking: "Confirming payment...", added: "Credits added!", updated: "Your balance has been updated.",
    notDone: "Payment not completed", stillProcessing: "Still processing", noCharge: "You were not charged.",
    refresh: "Refresh your dashboard in a moment.", goDash: "Go to dashboard",
  },
  errors: { generic: "Something went wrong. Please try again." },
  faq: { title: "Frequently asked questions", related: "Related tools and guides" },
  hub: { guidesHint: "New to print files? Read the" },
  guide: { updated: "updated" },
  notFound: { title: "Page not found", sub: "The link may be broken or the page may have moved.", home: "Back to home", tools: "See all tools" },
  examples: {
    eyebrow: "Real examples", title: "See the difference before you print",
    sub: "These results were made by our own tools, untouched.",
    ampliar: "A small, blurry low-resolution photo enlarged 4x, with natural faces and sharp enough to print.",
    vetorizar: "A blurry, low-quality logo turned into clean vector curves.",
    "remover-fundo": "A real photo with a busy background, now with a clean transparent background.",
    pdfPages: "pages", pdfCaption: "One PDF in, every page out as JPG, PNG, BMP or TIFF",
    "pdf-imagem": "Upload a PDF document and export every page as JPG, PNG, BMP or TIFF, from 150 to 600 DPI, in RGB or CMYK.",
    before: "Before", after: "After", drag: "Drag to compare", try: "Try it with your file",
  },
  alert: {
    lastTitle: "Only 1 image left",
    emptyTitle: "You've used all your images",
    text: "Get 10 more for US$5 and keep fixing your files. Credits never expire.",
    cta: "Buy 10 for US$5",
    googleOnly: "Credits can only be used with a Google account. Log out and sign in with Google to use your images.",
    switchCta: "Sign in with Google",
  },
  promo: {
    guest: "5 FREE images on any tool. Just sign in with Google, no card needed.",
    guestCta: "Claim now",
    userOne: "You have 1 credit left · 1 credit = 1 download · Get 10 more for US$5",
    googleOnly: "Credits work only with Google sign-in. Tap to switch account.",
    user: "You have {n} credits left · 1 credit = 1 download · Get 10 more for US$5",
    unlimited: "Unlimited credits active on your account",
  },
  free: {
    badgeNum: "5 FREE",
    badge: "images to start, no card",
    note: "Sign in with your Google account to use your 5 free images. Preview free and use 1 credit only when you download.",
    sticker: "free images",
    authTitle: "5 free images waiting for you",
    authText: "Sign in to unlock them. Your credits stay linked to your account.",
    dashLeft: "free images left",
  },
  owner: {
    eyebrow: "Owner", title: "Site overview", menu: "Owner panel",
    users: "Users", usersSub: "+{d7} in 7 days · +{d30} in 30 days",
    files: "Files processed", filesSub: "{d7} in the last 7 days · {f} failed",
    sales: "Revenue", salesSub: "{n} sales · {c} credits sold · {b} buyers",
    chartFiles: "Files processed per day (30 days)", chartRevenue: "Revenue per day (30 days)",
    byTool: "By tool", topCustomers: "Top customers", allSales: "All sales", exportCsv: "Export CSV", colCustomer: "Customer", colSpent: "Total spent", colOrders: "Orders", colCredits: "Credits", colFiles: "Files", colLast: "Last purchase", colDate: "Date", colPacks: "Packs", colAmount: "Amount", recentSales: "Latest sales", recentUsers: "Latest sign-ups", noSales: "No sales yet",
  },
};
